import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-76607850"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content_field !tw-mb-4" }
const _hoisted_2 = { class: "sort__wrapper" }
const _hoisted_3 = ["src"]

import { ref } from "vue";
import Text from "@/core/uni-components/Text.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ProjectBanner',
  emits: ["update-search"],
  setup(__props, { emit: __emit }) {

const searchQuery = ref("");
const showBanner = ref(true);
const emit = __emit;

const updateSearch = () => {
  emit("update-search", searchQuery.value);
};
const onCloseBanner = () => {
  showBanner.value = false;
};

return (_ctx: any,_cache: any) => {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_radio = _resolveComponent("v-radio")!
  const _component_v_radio_group = _resolveComponent("v-radio-group")!
  const _component_v_menu = _resolveComponent("v-menu")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_text_field, {
      "prepend-inner-icon": "mdi-magnify",
      class: "input_field",
      placeholder: "Search",
      variant: "outlined",
      modelValue: searchQuery.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchQuery).value = $event)),
      onInput: updateSearch
    }, null, 8, ["modelValue"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_v_menu, {
        persistent: true,
        "close-on-content-click": false,
        class: "desktop_sort_menu"
      }, {
        activator: _withCtx(({ props }) => [
          _createVNode(_component_v_btn, _mergeProps(props, { variant: "plain" }), {
            default: _withCtx(() => [
              _createTextVNode(" Sort By "),
              _createElementVNode("span", null, [
                _createElementVNode("img", {
                  src: require('@/assets/icons/sort.svg'),
                  alt: ""
                }, null, 8, _hoisted_3)
              ])
            ]),
            _: 2
          }, 1040)
        ]),
        default: _withCtx(() => [
          _createVNode(_component_v_radio_group, { class: "tw-bg-white tw-rounded-[8px] tw-py-[1rem] tw-pr-[1rem] tw-pl-[.5rem]" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_radio, {
                label: "Most Recent",
                value: "ASC",
                color: "indigo"
              }),
              _createVNode(_component_v_radio, {
                label: "Oldest",
                value: "DESC",
                color: "indigo"
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ])
  ]))
}
}

})